import React, { useState } from 'react';
import './PantallaInicial.css';
import { useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { CSSTransition } from 'react-transition-group';
import twitterLogo from '../Imagenes/logo-white.png';
import googleLogo from '../Imagenes/google-logo.png';
import TaaptLogo from '../Imagenes/TaaptLogo.png';
import FondoInicio from '../Imagenes/Gif/FondoInicioSesion_LENTO.gif';
import { GoogleLogin, googleLogout, useGoogleLogin } from '@react-oauth/google';
import axios from 'axios';

const PantallaInicial: React.FC = () => {
  const [loginData, setLoginData] = useState({
    identifier: '',           
    password: '',              
    nombre: '',                
    nombre_usuario: '',        
    correo_electronico: '',    
    contraseña: '',            
    repetirContraseña: ''      
  });

  const [emailError, setEmailError] = useState(''); 
  const [passwordError, setPasswordError] = useState(''); 
  const [nombreUsuarioSugerencias, setNombreUsuarioSugerencias] = useState<string[]>([]); 
  const [checkingUsername, setCheckingUsername] = useState(false);

  const validarEmail = (email: string): boolean => {
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
  };

  const validarContraseña = (contraseña: string): boolean => {
    const re = /^(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*?&]{8,}$/;
    return re.test(contraseña);
  };

  const [isRegister, setIsRegister] = useState(false);
  const history = useHistory();
  const styles = {
    background: `url(${FondoInicio}) no-repeat center center fixed`,
    backgroundSize: 'cover',
    height: '87vh',
  };

  const handleChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setLoginData(prevData => ({
      ...prevData,
      [name]: value
    }));

    if (name === 'correo_electronico') {
      if (!validarEmail(value)) {
        setEmailError('Correo no válido');
      } else {
        setEmailError('');
      }
    }

    if (name === 'contraseña' || name === 'repetirContraseña') {
      if (!validarContraseña(loginData.contraseña)) {
        setPasswordError('La contraseña debe tener al menos 8 caracteres, incluir un número y una letra mayúscula');
      } else {
        setPasswordError('');
      }
    }

    if (name === 'nombre_usuario') {
      setCheckingUsername(true);
      try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001'}/check-username?nombre_usuario=${value}`);
        const data = await response.json();

        if (data.exists) {
          // Generar sugerencias aleatorias
          const randomSuggestions = Array(3)
            .fill(null)
            .map(() => `${value}_${Math.floor(1000 + Math.random() * 9000)}`);
          setNombreUsuarioSugerencias(randomSuggestions);
        } else {
          setNombreUsuarioSugerencias([]);
        }

      } catch (error) {
        console.error('Error al verificar el nombre de usuario:', error);
      }

      setCheckingUsername(false);
    }
  };

  const [loginErrors, setLoginErrors] = useState({
    identifier: '',
    password: ''
  });

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001';
      console.log("url: "+ backendUrl);
      const response = await fetch(`${backendUrl}/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ identifier: loginData.identifier, password: loginData.password }),
      });

      const data = await response.json();

      if (response.ok) {
        localStorage.setItem('token', data.token);
        localStorage.setItem('expiration', JSON.stringify(Date.now() + 6 * 3600 * 1000));
        localStorage.setItem('userId', data.id_usuario.toString());
        history.push('/PerfilPage');
      } else {
        if (data.mensaje === 'Usuario no encontrado. Verifica tu nombre de usuario o correo electrónico.') {
          setLoginErrors(prevErrors => ({ ...prevErrors, identifier: 'Usuario no encontrado.' }));
        } else if (data.mensaje === 'Contraseña incorrecta.') {
          setLoginErrors(prevErrors => ({ ...prevErrors, password: 'Contraseña incorrecta.' }));
        } else {
          alert('Error en el inicio de sesión.');
        }
      }
    } catch (error) {
      console.error('Error al conectar con el servidor:', error);
      alert('Error de conexión con el servidor');
    }
  };

  const [errors, setErrors] = useState({
    nombre: '',
    nombre_usuario: '',
    correo_electronico: '',
    contraseña: ''
  });

  const handleRegisterSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
  
    if (loginData.contraseña !== loginData.repetirContraseña) {
      setPasswordError('Las contraseñas no coinciden');
      return;
    }
  
    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001';
  
      const response = await fetch(`${backendUrl}/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          nombre: loginData.nombre,
          nombre_usuario: loginData.nombre_usuario,
          correo_electronico: loginData.correo_electronico,
          contraseña: loginData.contraseña
        }),
      });
  
      const data = await response.json();
  
      if (response.ok) {
        if (data.token && typeof data.token === 'string') {
          localStorage.setItem('token', data.token);
        }
        localStorage.setItem('expiration', JSON.stringify(Date.now() + 6 * 3600 * 1000));
        if (data.id_usuario && typeof data.id_usuario === 'number') {
          localStorage.setItem('userId', data.id_usuario.toString());
        }
        history.push('/CheckoutPage');
      } else {
        if (data.error) {
          setErrors(prevErrors => ({ ...prevErrors, ...data.error }));
        } else {
          alert('Error en el registro. Por favor, inténtelo de nuevo.');
        }
      }
    } catch (error) {
      console.error('Error al conectar con el servidor:', error);
      alert('Error de conexión con el servidor. Por favor, verifique su conexión e inténtelo de nuevo.');
    }
  };
  const handleTwitterLogin = () => {
    // Redirige al backend para iniciar el proceso de autenticación con Twitter
    window.location.href = 'https://taapt.vercel.app/twitter/login';  // Cambia la URL de localhost por tu backend en producción
  };
  // Función para manejar el inicio de sesión con Google
  const handleGoogleLogin = async (credential: string | undefined) => {
    if (!credential) {
      console.error('No se recibió el token de Google');
      return;
    }

    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001';
      
      const response = await axios.post(`${backendUrl}/auth/google`, {
        token: credential,
      });

      if (response.data.token) {
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('expiration', JSON.stringify(Date.now() + 6 * 3600 * 1000));
        localStorage.setItem('userId', response.data.id_usuario.toString());
        history.push('/PerfilPage');
      } else {
        alert('Error en la autenticación con Google.');
      }
    } catch (error) {
      console.error('Error al autenticar con Google:', error);
      alert('Error al autenticar con Google. Por favor, inténtelo de nuevo.');
    }
  };
  
  return (
    <div className="pantalla-inicial" style={styles}>
      <Helmet>
        <title>Inicio</title>
      </Helmet>
      <div className="pantalla-inicial-content">
        <img className="Logo-Inicio" src={TaaptLogo} alt="Taapt Logo" />
        <div className="form-container">
          <div className="tab-container">
            <button
              className={`tab ${!isRegister ? 'active' : ''}`}
              onClick={() => setIsRegister(false)}
            >
              Iniciar Sesión
            </button>
            <button
              className={`tab ${isRegister ? 'active' : ''}`}
              onClick={() => setIsRegister(true)}
            >
              Registrarse
            </button>
          </div>

          {/* Login Form */}
          <CSSTransition
            in={!isRegister}
            timeout={300}
            classNames="form-transition"
            unmountOnExit
          >
            <form className="form" onSubmit={handleSubmit}>
              <input
                type="text"
                name="identifier"
                placeholder="Correo electrónico o Nombre de usuario"
                value={loginData.identifier}
                onChange={handleChange}
              />
              {loginErrors.identifier && <p className="error">{loginErrors.identifier}</p>}

              <input
                type="password"
                name="password"
                placeholder="Contraseña"
                value={loginData.password}
                onChange={handleChange}
              />
              {loginErrors.password && <p className="error">{loginErrors.password}</p>}

              <button type="submit" className="submit-button">Iniciar Sesión</button>
            </form>
          </CSSTransition>

          {/* Registro Form */}
          <CSSTransition
            in={isRegister}
            timeout={300}
            classNames="form-transition"
            unmountOnExit
          >
            <form onSubmit={handleRegisterSubmit} className="form">
              <input
                type="text"
                name="nombre"
                placeholder="Nombre"
                value={loginData.nombre}
                onChange={handleChange}
              />
              {errors.nombre && <p className="error">{errors.nombre}</p>}

              <input
                type="text"
                name="nombre_usuario"
                placeholder="Nombre de usuario"
                value={loginData.nombre_usuario}
                onChange={handleChange}
              />
              {errors.nombre_usuario && <p className="error">{errors.nombre_usuario}</p>}
              {nombreUsuarioSugerencias.length > 0 && (
                <div className="sugerencias">
                  <p>El nombre de usuario ya existe, prueba con:</p>
                  {nombreUsuarioSugerencias.map(sugerencia => (
                    <p key={sugerencia} className="sugerencia-item" onClick={() => setLoginData({ ...loginData, nombre_usuario: sugerencia })}>
                      {sugerencia}
                    </p>
                  ))}
                </div>
              )}

              <input
                type="email"
                name="correo_electronico"
                placeholder="Correo electrónico"
                value={loginData.correo_electronico}
                onChange={handleChange}
              />
              {errors.correo_electronico && <p className="error">{errors.correo_electronico}</p>}
              {emailError && <p className="error">{emailError}</p>}

              <input
                type="password"
                name="contraseña"
                placeholder="Contraseña"
                value={loginData.contraseña}
                onChange={handleChange}
              />
              {errors.contraseña && <p className="error">{errors.contraseña}</p>}
              {passwordError && <p className="error">{passwordError}</p>}

              <input
                type="password"
                name="repetirContraseña"
                placeholder="Repetir Contraseña"
                value={loginData.repetirContraseña}
                onChange={handleChange}
              />

              <button type="submit">Registrar</button>
            </form>
          </CSSTransition>

          <p className="or-connect">o conéctate con tus redes sociales</p>
          <div className="social-buttons">
            <button className="social-button twitter-button" onClick={handleTwitterLogin}><img src={twitterLogo} alt="Twitter" /></button>
            
            {/* Botón de Google Sign-In */}
            <GoogleLogin
              onSuccess={credentialResponse => {
                // Manejar la respuesta exitosa
                handleGoogleLogin(credentialResponse.credential);
              }}
              onError={() => {
                console.log('Login Failed');
              }}
              useOneTap
            />
          </div>
        </div>
      </div>
    </div>
  );
  
};

export default PantallaInicial;
